export enum PickerStatusE {
  NEW = 0,
  WAITING_FOR_SELECTION,
  IN_SELECTING,
  SELECTION_COMPLETED,
  VIEW_ONLY,
  DELETED = 6,
}

export enum EventTypeE {
  "Wedding" = 1,
  "Bar / Bat Mizva" = 2,
  "Hina" = 4,
  "Brit" = 5,
  "Others" = 6,
  "Sweet 16" = 7,
  "Baby" = 8,
  "Family" = 9,
  "Birthday" = 10,
  "Youth Party" = 11,
}

export const EventTypes: { [key: number]: string } = {
  0: "No event type",
  1: "Wedding",
  2: "Bar / Bat Mizva",
  4: "Hina",
  5: "Brit",
  6: "Others",
  7: "Sweet 16",
  8: "Baby",
  9: "Family",
  10: "Birthday",
  11: "Youth Party",
};

export const pickerStatuses: {
  [key: string]: number;
} = {
  'new': 0,
  "waiting-for-selection": 1,
  "in-selection": 2,
  "selection-completed": 3,
  "view-only": 4,
  "deleted": 5,
  "disabled": 6,
};

export const pickerStatusColors: { [key: string]: string } = {
  "waiting-for-selection": "#F8C237",
  "in-selection": "#56C6EA",
  "selection-completed": "#8BC668",
  "view-only": "#9594DC",
  "disabled": "#f44336",
};
